// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"c80a1657","405":"132a5db8","812":"8015ee15"}[chunkId] + ".chunk.css";
};